import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import DelayedTextInputContainer from '@af-common/Common/_containers/DelayedTextInputContainer';
import { OnChangeWidth } from '../_actions/DocumentActions';

const mapStateToProps = (store:Store) => ({
	value: store.getIn(['create', 'document', 'width'])
});

const mapDispatchToProps = (dispatch:Dispatch) => ({
	onChange: (value:string) => dispatch(OnChangeWidth(Number(value)))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DelayedTextInputContainer);